import React from "react";
import BaseCarTypeFilter from "./baseCarType";

const bidOptions = [
    { label: "Без свойств", value: 1 },
    { label: "В рамках заявки", value: 2 },
    { label: "Не в рамках заявки", value: 3 },
];

const predicates = {
    1: null,
    2: (el) => el.bidId !== null && el.bidId !== 0,
    3: (el) => el.bidId === null || el.bidId === 0,
};

const GroupedByBidId = (props) => {
    const { value, filterData } = props;
    const selectProps = {
        inputProps: { name: "bidId" },
        setValue: (data) => filterData({ ...data, predicate: predicates[data.value] }),
        placeholder: "",
        options: bidOptions,
        unClearable: true,
        value,
    };
    return (
        <div className="w-100">
            <BaseCarTypeFilter {...props} selectProps={selectProps} />
        </div>
    );
};

export default GroupedByBidId;
